import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=1e4170e2&scoped=true&"
import script from "./ExpandableText.vue?vue&type=script&lang=js&"
export * from "./ExpandableText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=1e4170e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4170e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
